module.exports = __webpack_public_path__ + "img/confirmfebvideoflow-header.c2baee71.jpg";